// extracted by mini-css-extract-plugin
export default {"base":"EditComment_base__vFqxG","label":"EditComment_label__kLRET","field":"EditComment_field__bGWG8"};